module.exports = __webpack_public_path__ + "static/female_cofounders_logo-b31d733f2c9ac0796345c0cf7741ce33.svg";